import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { urls } from '../router/urls';
import axios from 'axios';
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import './Collections.css';

const CollectionCard = ({ id, img, title, description }) => {

  return (
    <li className="col-xs-12 col-sm-6 col-md-4 col-lg-3 mt-3">
      <Link
        to={`/${urls.agrupaciones}/${id}`}
        style={{ color: '#666 !important' }}
        aria-label={title}
      >
        <div className="card border">
          <img src={img} className="card-img-top" alt="" />
          <div className="card-body">
            <h5 className="card-title text-truncate">{title}</h5>
            <p className="card-text height-10">
              {description.substring(0, 100)}
            </p>
          </div>
        </div>
      </Link>
    </li>
  );
};

const Collections = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    let query = window.location.search;
    let params = new URLSearchParams(query);
    let initialQuery = params.get('query') || 'Todos';
    let initialPage = params.get('page') || 1;
    setFilter(initialQuery);
    setPage(initialPage);
    getCollections(initialPage, initialQuery);
  }, []);

  const { t } = useTranslation();
  const [filter, setFilter] = useState('Todos');
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [numRes, setNumRes] = useState(0);
  const [data, setData] = useState([]);

  const getCollections = (pag, filter) => {
    let url =
      urls.url_api +
      '/api/resource-objects-grouping/?page_size=12&include_grouping_resources=False&';

    axios.get(url + 'letter=' + filter + '&page=' + pag).then(response => {
      setPageCount(Math.ceil(response.data.count / 12));
      setData(response.data.results);
      setNumRes(response.data.count);
    });
  };

  const onPageChange = data => {
    window.scrollTo(0, 0);
    let selected = data.selected;
    setPage(selected + 1);
    getCollections(selected + 1, filter);
    window.scrollTo(0, 0);
  };

  const onFilterCollections = e => {
    setFilter(e.target.value);
    getCollections(page, e.target.value);
  };

  return (
    <>
      <div className="demo row options-between">
        <h3 className="mb-3 work-sans-pwa link-share col-8 float-left">
          {t('header_colecciones') + ' (' + numRes + ')'}
        </h3>
      </div>

      <section className="row">
        <div className="col-md-12 text-center">
          <ul className="list-inline">
            {[...'1234567890ABCDEFGHIJKLMNÑOPQRSTUVWXYZ'].map(
              (character, index) => (
                <li className="list-inline-item" key={index}>
                  <input
                    className={
                      character === filter
                        ? 'abc-items bg-white fs-lg active'
                        : 'abc-items bg-white fs-lg'
                    }
                    type="submit"
                    value={character}
                    name="letter"
                    onClick={onFilterCollections}
                  />
                </li>
              )
            )}
            <li className="list-inline-item">
              <input
                className={
                  'Todos' === filter
                    ? 'abc-items bg-white fs-lg active'
                    : 'abc-items bg-white fs-lg'
                }
                type="submit"
                value="Todos"
                name="letter"
                onClick={onFilterCollections}
              />
            </li>
          </ul>
        </div>
      </section>

      <section className="row" style={{ marginRight: 0, marginLeft: 0 }}>
        <ul className="simple-ul">
          {data.map((collection, index) => (
            <CollectionCard
              key={index}
              img={urls.url_api + collection.image}
              description={collection.description}
              title={collection.title}
              id={collection.id}
            />
          ))}
        </ul>
      </section>

      {numRes > 0 ? (
        <div className="row options-between tab-content">
          <ReactPaginate
            previousLabel={'«'}
            nextLabel={'»'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={3}
            onPageChange={onPageChange}
            containerClassName={'pagination my-4'}
            subContainerClassName={'pages pagination'}
            activeClassName={'active'}
            pageLinkClassName={'page-link'}
            pageClassName={'page-item'}
            previousClassName={'page-item'}
            nextClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextLinkClassName={'page-link'}
          />
        </div>
      ) : (
        <div className="col-md-12 text-center mb-6">
          <h2>{t('sin_colecciones_para_mostrar')}</h2>
        </div>
      )}
    </>
  );
};

export default Collections;
